import {Component} from '@angular/core';

@Component({
    selector: 'app-server-status',
    templateUrl: './server-status.component.html',
    styleUrls: ['./server-status.component.css'],
    standalone: false
})
export class ServerStatusComponent {

}
